import { createFileRoute } from '@tanstack/react-router';
import type { ReactElement } from 'react';

import { DashboardInsightPage } from '~/features/insights/insight-page';

/** A Dashboard insight on its own page (board "An insight, opened"). */
function InsightRoute(): ReactElement {
  const { cardId } = Route.useParams();
  return <DashboardInsightPage key={cardId} cardId={cardId} />;
}

export const Route = createFileRoute('/_app/dashboard/$cardId/')({ component: InsightRoute });
